// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import IconButton from '../IconButton/IconButton';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import CSSTransition from 'react-transition-group/CSSTransition';

import './BackToTopButton.less';

import type {State as ReduxState} from '../../reducers/index';

export type StateProps = {
    showMobileScroller?: boolean
};
export type Props = {
    clickHandler: () => mixed
} & StateProps;

export class BackToTopButton extends Component<Props> {
    props: Props;
    shouldComponentUpdate(nextProps: Props): boolean {
        if (!this.props.showMobileScroller && nextProps.showMobileScroller) {
            edapTrigger(GENERIC_EVENT, {
                eventaction: 'back to top appears',
                highfrequency: 'true'
            });
        }
        return nextProps.showMobileScroller !== this.props.showMobileScroller;
    }

    render() {
        const {clickHandler, showMobileScroller} = this.props;
        return (
            <CSSTransition
                in={showMobileScroller}
                classNames="backtotop__transition"
                timeout={400}
                mountOnEnter
                unmountOnExit
            >
                <div
                    className="backtotop__button"
                    data-wdio="BackToTopButton"
                    key="mobileToTopButton"
                >
                    <IconButton icon="back-to-top" onClick={clickHandler} />
                </div>
            </CSSTransition>
        );
    }
}

const mapStateToProps = ({
    display: {showMobileScroller}
}: ReduxState): StateProps => ({
    showMobileScroller
});

export default compose(connect(mapStateToProps))(BackToTopButton);
